module.exports = __webpack_public_path__ + "img/nutrition-child-2.8247c3bf.png";